import styled from 'styled-components';
import { Modal } from 'antd';

export const CustomModal = styled(Modal)`
  .ant-modal-close {
    width: 16px;
    height: 16px;
    top: 24px;
    right: 24px;
  }
`;

export const SummaryBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: #2a2c2e;
  border-radius: 6px;
  height: 38px;
  padding: 4px 12px;
  margin-bottom: 16px;
`;

export const SummaryText = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  color: #ffffff;
`;

export const Dot = styled.span`
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background-color: #ffffff;
`;

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  letter-spacing: -0.36px;
`;

export const Label = styled.span`
  color: #b3b5bd;
`;

export const Value = styled.span`
  color: #ffffff;
`;

export const CheckboxWrapper = styled.div`
  margin-top: 42px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CheckboxLabel = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  letter-spacing: -0.36px;
  line-height: 1;
  position: relative;
  top: 1px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 20px;
`;

export const CancelButton = styled.button`
  flex: 1;
  height: 38px;
  border-radius: 12px;
  border: 1px solid #353535;
  background-color: transparent;
  color: #ffffff;
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: #07d993;
  }
`;

export const ConfirmButton = styled.button<{ $bgColor: string }>`
  flex: 1;
  height: 38px;
  border-radius: 12px;
  border: none;
  background-color: ${({ $bgColor }) => $bgColor};
  color: #0d1117;
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-1px);
    background-color: transparent;
    border: 1px solid #07d993;
    color: #fff;
  }
`;

export const BottomSheetContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 12px 20px 12px;

  ${InfoList} {
    gap: 6px;
  }

  ${SummaryText} {
    font-size: 15px;
  }

  ${InfoRow} {
    font-size: 12px;
    letter-spacing: -0.33px;
  }

  ${CheckboxLabel} {
    font-size: 13px;
  }

  ${CancelButton}, ${ConfirmButton} {
    height: 42px;
    font-size: 15px;
  }

  ${CheckboxWrapper} {
    margin-top: 20px;
  }

  ${ButtonContainer} {
    margin-top: 20px;
  }
`;

export const MobileHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  margin-bottom: 12px;
`;

export const MobileTitle = styled.p`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: normal;
  letter-spacing: -0.42px;
  color: #ffffff;
  margin: 0;
`;
